import { useUpdateTenant } from '../../api/tenants';
import { useUsers } from '../../api/users';
import { errorMessage } from '../../api/client';
import { displayName, ROLE_LABELS, type Tenant } from '../../api/types';

/** The tenant's Balsam contact; admins pick another staff member, others just see who it is. */
export function AccountManager({
  tenant,
  canAssign,
  onChanged,
}: {
  tenant: Tenant;
  canAssign: boolean;
  /** Re-validates the console context so the selected tenant shows its new manager. */
  onChanged: () => void;
}) {
  const staffQuery = useUsers({ userType: 'staff', limit: 100 }, { enabled: canAssign });
  const staff = staffQuery.isError ? [] : staffQuery.data?.data;
  const update = useUpdateTenant();
  const error = update.error ? errorMessage(update.error) : null;

  const assign = (accountManagerId: string) => {
    update.mutate(
      { tenantId: tenant.id, body: { accountManagerId: accountManagerId || null } },
      { onSuccess: () => onChanged() },
    );
  };

  if (!canAssign || !staff) {
    return tenant.accountManager ? (
      <>
        {tenant.accountManager.email}{' '}
        <span className="muted">({ROLE_LABELS[tenant.accountManager.role]})</span>
      </>
    ) : (
      <span className="muted">Unassigned</span>
    );
  }
  return (
    <>
      <select
        className="field__input"
        aria-label="Account manager"
        value={tenant.accountManagerId ?? ''}
        disabled={update.isPending}
        onChange={(e) => assign(e.target.value)}
      >
        <option value="">Unassigned</option>
        {staff.map((u) => (
          <option key={u.id} value={u.id}>
            {displayName(u)} ({ROLE_LABELS[u.role]})
          </option>
        ))}
      </select>
      {error ? <p className="field__error">{error}</p> : null}
    </>
  );
}
